import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[disallowSpaces]',
    standalone: false
})
export class DisallowSpacesDirective {

  constructor(private ngControl: NgControl) { }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    this.sanitizeInput();
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const sanitizedText = pastedText.replace(/\s+/g, '');
    this.ngControl.control?.setValue(sanitizedText);
  }

  private sanitizeInput(): void {
    const currentValue = this.ngControl.control?.value || '';
    const sanitizedValue = currentValue.replace(/\s+/g, '');
    if (currentValue !== sanitizedValue) {
      this.ngControl.control?.setValue(sanitizedValue);
    }
  }
}
